import { defineComponent as _defineComponent } from 'vue'
import { BcxFormField } from '@/models/BcxForm';
import Vue, { computed, PropType, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { i18nToItemList } from '@/utils/selectItemTools';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { ComponentInvoicePaymentData } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePaymentDataEditor',
  props: {
  paymentData: {
    type: Object as PropType<ComponentInvoicePaymentData>,
    required: true,
  }
},
  setup(__props) {

const props = __props;




const { errorMessages, findChangedProps } = useInvoice();
const { tUserFallback: t } = useUser('self');
const { isMobileWidth } = useResponsiveness();
const horizontalGap = isMobileWidth.value ? '16px' : '40px';

const paymentDataVM = useVModel(props, 'paymentData');

const reverseChargeOptions = [
  {
    value: true,
    text: `${t('invoice.payment-data.reverseChargeOptions.true')}`,
  },
  {
    value: false,
    text: `${t('invoice.payment-data.reverseChargeOptions.false')}`,
  },
];

const taxRateOptions = [
  {
    value: 7.7,
    text: `${t('invoice.payment-data.taxOptions.7,7')}`,
  },
  {
    value: 19,
    text: `${t('invoice.payment-data.taxOptions.19')}`,
  },
  {
    value: 20,
    text: `${t('invoice.payment-data.taxOptions.20')}`,
  },
];

const fieldsBase = computed(() => {
  const isMobile = isMobileWidth.value;
  const fields:BcxFormField[] = [
    {
      name: 'accountName',
      width: isMobile ? '60%' : '67%',
      label: `${t('invoice.payment-data.form.accountName')}`,
      type: 'text',
      textOptions: {
        maxLength: 70,
        hideCharsLeft: true
      }
    },
    {
      name: 'currency',
      width: isMobile ? '40%' : '33%',
      label: `${t('invoice.payment-data.form.currency_USERTYPE')}`,
      type: 'select',
      options: i18nToItemList('invoice.payment-data.currencyOptions').value ?? [],
    },
    {
      name: 'iban',
      width: isMobile ? '100%' : '67%',
      type: 'text',
      label: `${t('invoice.payment-data.form.iban_USERTYPE')}`,
      textOptions: {
        maxLength: 34,
        hideCharsLeft: true
      }
    },
    {
      name: 'bic',
      width: isMobile ? '100%' : '67%',
      type: 'text',
      label: `${t('invoice.payment-data.form.bic_USERTYPE')}`,
      textOptions: {
        maxLength: 11,
        hideCharsLeft: true
      }
    },
  ];
  return fields;
});

const fieldsTax = computed(() => {
  const isMobile = isMobileWidth.value;
  const reverseChargeTaxId: BcxFormField = {
    name: 'reverseChargeTaxId',
    width: isMobile ? '100%' : '33%',
    type: 'text',
    label: `${t('invoice.payment-data.form.reverseChargeTaxId_USERTYPE')}`,
    justify: 'end',
    textOptions: {
      maxLength: 20,
      hideCharsLeft: true
    }
  };
  const fields:BcxFormField[] = [
    {
      name: 'taxId',
      width: isMobile ? '100%' : '33%',
      type: 'text',
      label: `${t('invoice.payment-data.form.taxId_USERTYPE')}`,
      textOptions: {
        maxLength: 20,
        hideCharsLeft: true
      }
    },
    {
      name: 'taxRate',
      width: isMobile ? '50%' : '34%',
      type: 'select',
      options: taxRateOptions,
      mode: 'hybrid',
      label: `${t('invoice.payment-data.form.taxRateWithPercent_USERTYPE')}`,
      disabled: paymentDataVM.value?.reverseCharge,
      showDisabledLabel: true
    },
    {
      name: 'reverseCharge',
      width: isMobile ? '50%' : '33%',
      type: 'select',
      label: `${t('invoice.payment-data.form.reverseCharge_USERTYPE')}`,
      options: reverseChargeOptions,
    },
    ...(paymentDataVM.value?.reverseCharge ? [{ ...reverseChargeTaxId }] : []),
  ];
  return fields;
});

watch(
  () => paymentDataVM.value,
  (newValue: ComponentInvoicePaymentData, oldValue: ComponentInvoicePaymentData) => {
    // true → false
    if (oldValue.reverseCharge && !newValue.reverseCharge) Vue.set(paymentDataVM.value, 'taxRate', 19);
    // false → true
    if (!oldValue.reverseCharge && newValue.reverseCharge) Vue.set(paymentDataVM.value, 'taxRate', 0);

    const changed = findChangedProps(newValue, oldValue);
    const key = changed[0];

    if (changed.length === 1 && errorMessages.value[key]) {
      Vue.delete(errorMessages.value, key);
    }
  }
);

return { __sfc: true,props, errorMessages, findChangedProps, t, isMobileWidth, horizontalGap, paymentDataVM, reverseChargeOptions, taxRateOptions, fieldsBase, fieldsTax, BCXForm }
}

})